import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "rounded-full min-w-[2.5rem] w-10 h-10 bg-gray-300 overflow-hidden" }
const _hoisted_2 = ["src", "alt"]
const _hoisted_3 = { class: "w-[150px] text-center flex flex-col text-white gap-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_base_tooltip = _resolveComponent("base-tooltip")!

  return (_ctx.user)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(["flex gap-5 items-center overflow-hidden", {'cursor-pointer': _ctx.showConfiguration}])
      }, [
        _createElementVNode("div", _hoisted_1, [
          (_ctx.user.photoURL)
            ? (_openBlock(), _createElementBlock("img", {
                key: 0,
                src: _ctx.user.photoURL,
                alt: _ctx.user.name,
                class: "object-cover h-full w-full"
              }, null, 8, _hoisted_2))
            : _createCommentVNode("", true)
        ]),
        (_ctx.showConfiguration)
          ? (_openBlock(), _createBlock(_component_base_tooltip, {
              key: 0,
              options: {trigger: 'click', arrow: false, theme: 'white'}
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_3, [
                  _createElementVNode("p", {
                    class: "cursor-pointer hover:text-gray-400 transition-colors",
                    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.edit && _ctx.edit(...args)))
                  }, "Профиль"),
                  _createElementVNode("p", {
                    class: "cursor-pointer hover:text-gray-400 transition-colors",
                    onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.settings && _ctx.settings(...args)))
                  }, "Настройки"),
                  _createElementVNode("p", {
                    class: "cursor-pointer hover:text-gray-400 transition-colors",
                    onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.logout && _ctx.logout(...args)))
                  }, "Выход")
                ])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ], 2))
    : _createCommentVNode("", true)
}